import { createUiBindings } from '@ff-scene-plugins/photo-prints-redux/slices/generalUiSlice';

const { createSelector, createUpdateAction } = createUiBindings();

export const selectIsPhotoPrintsWindowOpen = createSelector(state => state.isPhotoPrintsWindowOpen);
export const setIsPhotoPrintsWindowOpen = createUpdateAction('isPhotoPrintsWindowOpen');

export const selectShowProjectIsIncompatible = createSelector(state => state.showProjectIncompatible);
export const setShowProjectIsIncompatible = createUpdateAction('showProjectIncompatible');